// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from 'firebase/app';

// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import 'firebase/analytics';

// Add the Firebase products that you want to use
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/database';

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
    apiKey: 'AIzaSyB5XapTWDCJcDhDkPDl5AnW1yEsJ1W4G1I',
    authDomain: 'pictionary-9aa0a.firebaseapp.com',
    databaseURL: 'https://pictionary-9aa0a.firebaseio.com',
    projectId: 'pictionary-9aa0a',
    storageBucket: 'pictionary-9aa0a.appspot.com',
    messagingSenderId: '121393137992',
    appId: '1:121393137992:web:951c14efc0b58b61e10b7d',
    measurementId: 'G-M4FL6YP9LP',
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const firestore = firebase.firestore();
export const database = firebase.database();

// firebase.database.enableLogging(true);
